import React, { useEffect, useState } from "react"
import { StyleSheet, Text, View, Image, TextInput, CheckBox } from "react-native";
import AppStyles from "../../../AppStyles";
import AppTheme from "../../../AppTheme";
import { store } from "../../../store/store";
import { updateReduxCurrentAnswer, updateReduxAnswerList, updateQuestionRenderState } from "../../services/redux/commonRedux";

export default function InputFeildWithNAFunc() {

    const [data, updateData] = useState({
        ansData : {},
        questionData : {},
        render : false
    })

    const [ansData, updateAnsData] = useState({
        inputText : '',
        isNASelected : false
    })

    // const [inputText, updateInputText] = useState('');

    function onChangeText(questionData, text, isNASelected) {
        updateAnsData({
            inputText : text,
            isNASelected : text.length == 0
        }); const id = questionData['qid'];
        const rskey = questionData['rskey']
        const ansVal = isNASelected ? questionData['naValue'] : text
        const curretAns = {
            [id] : {
                id : questionData['qid'],
                [rskey] : ansVal,
                textInput : {}
            },
        }; updateData({
            questionData : questionData,
            ansData : {},
            render : true
        }); updateReduxCurrentAnswer(curretAns);
    }

    useEffect(() => {
        const reduxState = store.getState();
        if (reduxState.renderQuestionElement) {
            updateQuestionRenderState(false);
            if(reduxState.currentConsultationQuestion) {
                const ansData = reduxState.currentConsultationAnswer;
                const qData = reduxState.currentConsultationQuestion;
                updateData({
                    ansData : reduxState.currentConsultationAnswer,
                    questionData : reduxState.currentConsultationQuestion,
                    render : true
                });
                if (ansData[qData['qid']])
                    updateAnsData({
                        inputText : ansData[qData['qid']][qData['rskey']] == qData['naValue'] ? '' : ansData[qData['qid']][qData['rskey']],
                        isNASelected : ansData[qData['qid']][qData['rskey']] == qData['naValue'],
                    });
                else updateAnsData({
                    inputText: '',
                    isNASelected: false,
                });
            }
        }
    })

    return <View style={{}}>
        {
            data.render ? <View>
                <View style={{marginHorizontal: 16}}>
                    <Text style={[AppStyles.questionText, { marginVertical: 12  }]}>
                        {data.questionData['qstr']}
                    </Text>
                    <TextInput style={[AppStyles.quesInput, {padding: 8}]}
                        multiline
                        numberOfLines={4}
                        placeholder={data.questionData['hint']}
                        defaultValue={ansData.inputText}
                        value={ansData.inputText}
                        // error is using both value and onChnageText, asking to use.
                        onChangeText={text => onChangeText(data.questionData, text.trim(), text.trim().length == 0)}
                    />
                    <Text  onPress={() => onChangeText(data.questionData, '', true)}>
                        <CheckBox
                            value={ansData.isNASelected}
                            style={AppStyles.checkbox}
                            color={ansData?.isNASelected ? AppTheme.color.primary : undefined}/>
                        {data.questionData['naDispStr']}
                    </Text>
                </View>
            </View> : <View></View>
        }
    </View>
}

